import {PasswordRequirements} from './PasswordRequirements';

export const PasswordSchema = PasswordRequirements.map(
  each => each.validator
).reduce((a, b) => a.concat(b));
